export const defaultText = {
  title: 'Page not found',
  subtitle: 'The requested URL was not found',
  homeButton: 'Back to Home',
} as const;
